// extracted by mini-css-extract-plugin
module.exports = {"modal":"PricesPageModal_modal__3a7yc"};